<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'samplemanage-sampleStockSummary',
  components: {
    PageTable,
  },
}
</script>
